import React from "react";
import PagePlaceholder from "../components/PagePlaceholder";

const NotFound = () => {
  return <PagePlaceholder title="404" description="Pagina nao encontrada." />;
};

export default NotFound;
